import env from './env'

const DEV_URL = 'http://192.168.0.100:9060/'
const PRO_URL = 'https://mobcore.gosmart.mn/'
//const PRO_URL = 'http://devapi.gosmart.mn/'
//const PRO_URL = 'http://e-learning.mta.mn/mobcore/'

export default env === '_development' ? DEV_URL : PRO_URL